import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import "./home.css";

import Header from "../../components/Header/Header";
import NSCardButton from "../../components/NSCardButton/NSCardButton";
import SimpleTitle from "../../components/SimpleTitle/SimpleTitle";
import DialogOVANCEUnderConstruction from "../../components/DialogOVANCEUnderConstruction";

import {
  Ic_AED,
  Ic_DAE,
  Ic_DEA,
  iconAhogo,
  iconCompresiones,
  iconMonitor,
  iconNotas,
} from "../../helpers/ImagesCache";

import useTranslation from "../../hooks/useTranslation";
import { TranslationContext } from "../../helpers/Context";
import { useAnalytics } from "../../hooks/useAnalytics";

const Home = () => {
  const T = useTranslation();
  const { language } = useContext(TranslationContext);
  const { trackSimulationStart, trackButtonClick, trackDialogOpen } = useAnalytics();

  const [showOvanceDialog, setShowOvanceDialog] = useState(false);

  // Determina el ícono de DEA según el idioma actual
  const getDEAIco = () => {
    switch (language) {
      case "EN":
        return Ic_AED;
      case "IT":
        return Ic_DAE;
      default:
        return Ic_DEA;
    }
  };

  const handleCloseOvanceDialog = () => {
    setShowOvanceDialog(false);
  };

  // Handlers con Analytics
  const handleAdvancedClick = () => {
    trackSimulationStart('advanced', {
      patient_type: 'adult',
      has_vascular_access: true,
      has_airway_device: true,
      source: 'home_page'
    });
  };

  const handleBasicClick = () => {
    trackSimulationStart('basic', {
      patient_type: 'adult',
      has_aed: true,
      source: 'home_page'
    });
  };

  const handleOVACEClick = () => {
    trackButtonClick('ovace_button', {
      source: 'home_page',
      dialog_triggered: true
    });
    setShowOvanceDialog(true);
  };

  const handleReportsClick = () => {
    trackButtonClick('reports_button', {
      source: 'home_page',
      destination: 'reports_page'
    });
  };

  const handleOVACEDialogOpen = () => {
    trackDialogOpen('ovace_under_construction', {
      source: 'home_page',
      user_intent: 'ovace_simulation'
    });
  };

  return (
    <div className="fixed h-[100dvh] w-full flex flex-col bg-[#F9FAFB] overflow-y-auto justify-center">
      <Header minimal />
      <div className="flex flex-1 justify-center px-6">
        <div className="flex flex-col w-full items-center justify-center gap-5  pb-2">
          <div className="flex flex-[1]"></div>
          <SimpleTitle text={T("homeTitle")} className="mb-7" />
          {/* Opciones principales de simulación */}

          <div className="w-full flex justify-between flex-wrap gap-5 md:flex-nowrap">
            <Link to="/advanced" className="flex-1" onClick={handleAdvancedClick}>
              <NSCardButton
                options={{
                  title: T("avancedLifeSupport"),
                  icon: iconMonitor,
                }}
              />
            </Link>

            <Link to="/basic" className="flex-1" onClick={handleBasicClick}>
              <NSCardButton
                options={{
                  title: T("Soporte vital básico + DEA"),
                  icon: iconCompresiones,
                  iconOptional: getDEAIco(),
                }}
              />
            </Link>

            <div
              className="flex-1"
              onClick={handleOVACEClick}
              role="button"
              tabIndex={0}
            >
              <NSCardButton
                options={{
                  title: T("OVACE"),
                  icon: iconAhogo,
                }}
              />
            </div>
          </div>

          {/* Acceso a los informes */}
          <Link to="/reports" className="max-w-[400px] w-full" onClick={handleReportsClick}>
            <NSCardButton
              options={{
                title: T("Informes"),
                icon: iconNotas,
                horizontal: true,
                fullWidth: true,
                horizontal: true,
              }}
            />
          </Link>
          <div className="flex flex-[2]"></div>
        </div>
      </div>
      <DialogOVANCEUnderConstruction
        visible={showOvanceDialog}
        onClose={handleCloseOvanceDialog}
      />
    </div>
  );
};

export default Home;
